import { Typography } from "@hellocarbo/lasagne";
import {
  Award,
  FileCheck,
  Globe2,
  Headset,
  Network,
  Recycle,
  RefreshCcw,
} from "lucide-react";
import { useTranslation } from "react-i18next";

import { proServicesKeys } from "@/constants/proServices";

import OptionItem from "./OptionItem";

type ServicesSectionProps = {
  title: string;
  services: typeof proServicesKeys;
};

const iconMap = {
  carboProduct: Recycle,
  carboService: RefreshCcw,
  additionalCoaching: Headset,
  ecovadis: Award,
  vsme: FileCheck,
  climateFresk: Globe2,
  cdpAssessment: Network,
};

function ServicesSection({ title, services }: ServicesSectionProps) {
  const { t } = useTranslation("options");

  return (
    <div>
      <Typography as="h2" step="1" weight="bold" className="mb-xs">
        {title}
      </Typography>
      <ul className="gap-sm grid grid-cols-1 xl:grid-cols-2">
        {services.map((service) => {
          const icon = iconMap[service as keyof typeof iconMap];

          return (
            <li key={service}>
              <OptionItem
                optionKey={service}
                title={t(`options:byProServices.serviceList.${service}.title`)}
                description={t(
                  `options:byProServices.serviceList.${service}.description`
                )}
                href="/options/subscription"
                tag={t(`options:byProServices.serviceList.${service}.tag`)}
                Icon={icon}
                tooltipContent={t("options:tooltip")}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default ServicesSection;
